<template>
  <div class="col-md-6 mb-3">
    <div class="zone-card card-item">
      <div class="zone-card-content">
        <!-- 상단: 영역 이름 + 삭제 버튼 -->
        <div class="zone-header-row">
          <div class="zone-title-wrapper" v-touch:hold="onTouchHold">
            <i class="fa-regular fa-house zone-icon"></i>
            <span class="zone-title">{{ props.data.name }}</span>
            <div class="zone-edit-btn" @click.stop="onEditClick">
              <i class="fa-solid fa-pencil"></i>
            </div>
          </div>
          <div class="zone-delete-btn" @click.stop="onDeleteClick">
            <i class="fa-regular fa-trash-can"></i>
          </div>
        </div>

        <!-- 중간: 방 정보 -->
        <div class="zone-info-row">
          <i class="fa-brands fa-microsoft zone-info-icon"></i>
          <span class="zone-info-text">
            <span class="zone-info-label">등록된 방 수:</span>
            <span class="zone-info-value">{{ props.data.groups.length }}개</span>
          </span>
        </div>

        <!-- 컨트롤러 경고 -->
        <div v-if="!hasController" class="zone-warning">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <span>컨트롤러가 등록되어 있지 않습니다.</span>
        </div>

        <!-- 하단: 방 관리 링크 -->
        <div class="zone-management-row" @click="onDetailClick">
          <span class="zone-management-link">방 관리</span>
          <i class="fa-solid fa-chevron-right"></i>
        </div>
      </div>
    </div>
    <ZoneModal
      v-if="zoneModal.visible"
      :visible="zoneModal.visible"
      :okCallback="onUpdateZoneName"
      :cancelCallback="zoneModal.hide"
      :zoneName="props.data?.name"
    />
  </div>
</template>

<script setup>
import { onMounted, defineProps, computed, getCurrentInstance ,reactive} from 'vue';
import Card from '@/common/template/components/bootstrap/Card.vue';
import CardBody from '@/common/template/components/bootstrap/CardBody.vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Axios, { ZoneApi } from '@/api';
import useMqttControl from '@/common/hooks/useMqttControl';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';
import ZoneModal from '@/views/rooms/components/ZoneModal.vue';
import useModal from '@/common/hooks/useModal';

const mqttControl = reactive(useMqttControl());
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const { emit } = getCurrentInstance();
const router = useRouter();
const props = defineProps(['index', 'data', 'onZoneUpdated']);
const store = useStore();
const zoneModal = reactive(useModal());
const backColor = computed(() => {
  if (props.index % 5 === 0) {
    return 'bg-gradient-custom-orange';
  } else if (props.index % 5 === 1) {
    return 'bg-gradient-custom-pink';
  } else if (props.index % 5 === 2) {
    return 'bg-gradient-custom-teal';
  } else if (props.index % 5 === 3) {
    return 'bg-gradient-custom-indigo';
  } else {
    return 'bg-gradient-custom-blue';
  }
});

onMounted(() => {
  console.log('ZoneItem.onMounted().props =>', props.data.controllers);
});
const hasController = computed(() =>{
  return props.data.controllers.length > 0
})
const onDetailClick = () => {

          router.push(`/settings/zones/${props.data._id}/groups`);
          return;

  console.log(
    'ZoneItem.onDetailClick => ',
    `/settings/zones/${props.data._id}`,
  );
  // if (props.data.controllers.length == 0) {
  //   emitter.emit('showPopAlert', {
  //     title: '컨트롤러 미등록',
  //     description: `컨트롤러를 먼저 등록해야합니다.\n컨트롤러 등록 화면으로 이동합니다.`,
  //     okCallback: () => {
  //       router.push(`/settings/zones/${props.data._id}/regist-controllers`);
  //     },
  //     cancelCallback:() =>{

  //     }
  //   });
  //   return;
  // }

  if(!props.data.isEditMode){
    emitter.emit('showPopAlert', {
      title: '세팅 모드',
      description: `세팅모드 화면으로 이동하시겠습니까?\n세팅모드 활성화시 모바일 기기에서 컨트롤이 제한됩니다.`,
      okCallback: async() => {
        const payload = {isEditMode:true}
        const result = await Axios.patch(
          ZoneApi.UPDATE_ZONE.replace(':id', props.data._id),
          payload,
        );
        if (result.resultCode === '0000') {
          mqttControl.onPublishZone(props.data._id,payload)
          router.push(`/settings/zones/${props.data._id}/groups`);
        }
      },
      cancelCallback:() =>{}
    });
    return
  }

  router.push(`/settings/zones/${props.data._id}/groups`);
  
};
const onRegistControllerClick = () => {
  router.push(`/settings/zones/${props.data._id}/regist-controllers`);
}
const onSettingControllerClick = () =>{
  router.push(`/settings/zones/${props.data._id}/setting-controllers`);
}

const onDeleteClick = () => {
  console.log('ZoneItem.onDeleteClick =>', {
    name: props.data.name,
    zoneId: props.data._id,
  });

  emitter.emit('showPopConfirm', {
    title: '영역 삭제',
    description: `${props.data.name} 영역을 삭제하시겠습니까?`,
    okText: "삭제",
    cancelText: '취소',
    okCallback: () => setTimeout(() => emit('onDeleteClick', { name: props.data.name, zoneId: props.data._id }), 100)
  });
};

const onTouchHold = () => {
  zoneModal.show();
}

const onEditClick = () => {
  zoneModal.show();
}

const onUpdateZoneName = (value) => {
  requestUpdateZone({
    name: value,
  });
  zoneModal.hide();
};

const requestUpdateZone = async (params) => {
  try {
    const result = await Axios.patch(
      ZoneApi.UPDATE_ZONE.replace(':id', props.data._id),
      params,
    );
    if (result.resultCode === '0000') {
      store.commit('home/updateZone', {
        id: props.data._id,
        data: params,
      });
      emit('onZoneUpdated');
    } else {
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
  } catch (error) {
    emitter.emit('showPopAlert', {
      description: '영역 정보 수정에 실패했습니다.',
    });
  }
};
</script>

<style scoped>
.zone-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.zone-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.zone-card-content {
  padding: 1.25rem;
}

.zone-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.zone-title-wrapper {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
}

.zone-icon {
  color: #0d6efd;
  font-size: 1.25rem;
}

.zone-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #212529;
}

.zone-edit-btn {
  cursor: pointer;
  padding: 0.5rem;
  color: #6c757d;
  transition: all 0.2s ease;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  margin-left: 0.25rem;
}

.zone-edit-btn:hover {
  background-color: #f8f9fa;
  color: #0d6efd;
}

.zone-delete-btn {
  cursor: pointer;
  padding: 0.5rem;
  color: #6c757d;
  transition: all 0.2s ease;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
}

.zone-delete-btn:hover {
  background-color: #f8f9fa;
  color: #dc3545;
}

.zone-info-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 0.5rem 0;
}

.zone-info-icon {
  color: #0d6efd;
  font-size: 1.1rem;
}

.zone-info-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.95rem;
}

.zone-info-label {
  color: #6c757d;
}

.zone-info-value {
  color: #212529;
  font-weight: 600;
}

.zone-warning {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 0.5rem;
  color: #856404;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.zone-warning i {
  color: #ffc107;
}

.zone-management-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  padding-top: 0.75rem;
  margin-top: 0.5rem;
  border-top: 1px solid #e9ecef;
  cursor: pointer;
  transition: all 0.2s ease;
}

.zone-management-row:hover {
  opacity: 0.8;
}

.zone-management-link {
  color: #198754;
  font-weight: 500;
  font-size: 0.95rem;
}

.zone-management-row i {
  color: #198754;
  font-size: 0.85rem;
}
</style>
